"use client";

import { c as _c } from "react/compiler-runtime";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import React, { useState } from "react";
import { FaEllipsis } from "react-icons/fa6";
import { cx } from "@/lib/tailwind-utils";

/**
 * @deprecated Use components/ui/dropdown.tsx instead.
 * This component will be removed in a future version.
 *
 * Migration guide:
 * - Replace SettingsMenu with DropdownMenu
 * - Replace SettingsDropdownItem with DropdownMenuItem
 * - Replace SettingsDropdownHeader with DropdownMenuLabel
 */

interface SettingsMenuProps {
  children: React.ReactNode;
  className?: string;
}
interface SettingsDropdownHeaderProps {
  children: React.ReactNode;
}
interface ChildProps {
  onClose?: () => void;
}

/**
 * @deprecated Use DropdownMenu from components/ui/dropdown.tsx instead.
 */
const SettingsMenu: React.FC<SettingsMenuProps> = t0 => {
  const $ = _c(16);
  const {
    children,
    className
  } = t0;
  const [open, setOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setOpen(false);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const onClose = t1;
  let t2;
  if ($[1] !== className) {
    t2 = cx("rounded-md  px-2 py-1 shadow-sm hover:bg-row-hover", "absolute right-0 top-0 -translate-x-2 translate-y-2 transform", "border border-border focus:outline-none focus:ring-0", className);
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FaEllipsis className="text-foreground-secondary" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <DropdownMenu.Trigger asChild={true}><button className={t2}>{t3}</button></DropdownMenu.Trigger>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = cx("z-10 mt-1 min-w-32 space-y-1 rounded-md p-1.5 shadow-lg", "border ", "focus:outline-none focus:ring-0", "font-medium hover:font-medium");
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== children) {
    let t7;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = child => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, {
            onClose
          });
        }
        return child;
      };
      $[9] = t7;
    } else {
      t7 = $[9];
    }
    t6 = React.Children.map(children, t7);
    $[7] = children;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <DropdownMenu.Content className={t5} align="end">{t6}</DropdownMenu.Content>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== open || $[13] !== t4 || $[14] !== t7) {
    t8 = <DropdownMenu.Root open={open} onOpenChange={setOpen}>{t4}{t7}</DropdownMenu.Root>;
    $[12] = open;
    $[13] = t4;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
type SettingsDropdownItemProps = {
  text: string;
  action: (event: React.MouseEvent<HTMLDivElement>) => void;
  onClose?: () => void;
  className?: string;
};

/**
 * @deprecated Use DropdownMenuItem from components/ui/dropdown.tsx instead.
 */
const SettingsDropdownItem: React.FC<SettingsDropdownItemProps> = t0 => {
  const $ = _c(10);
  const {
    text,
    action,
    onClose,
    className
  } = t0;
  let t1;
  if ($[0] !== action || $[1] !== onClose) {
    t1 = event => {
      event.stopPropagation();
      action(event);
      if (onClose) {
        onClose();
      }
    };
    $[0] = action;
    $[1] = onClose;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleClick = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cx("flex w-full cursor-pointer select-none items-center rounded-sm px-2 py-1 text-body text-foreground-secondary", "hover:bg-hover focus:bg-hover focus:outline-none hover:focus:ring-0");
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== className || $[5] !== text) {
    t3 = <div className={className}>{text}</div>;
    $[4] = className;
    $[5] = text;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== handleClick || $[8] !== t3) {
    t4 = <DropdownMenu.Item className={t2} onClick={handleClick}>{t3}</DropdownMenu.Item>;
    $[7] = handleClick;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};

/**
 * @deprecated Use DropdownMenuLabel from components/ui/dropdown.tsx instead.
 */
const SettingsDropdownHeader: React.FC<SettingsDropdownHeaderProps> = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="px-2 pt-2 text-caption-emphasis text-muted-foreground">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export { SettingsDropdownHeader, SettingsDropdownItem, SettingsMenu };